import React from 'react';
import { TextLink } from "@vds/buttons";
import { Title, Body } from "@vds/typography";
import styled from 'styled-components';
import { Accordion, AccordionDetail, AccordionItem, AccordionHeader, AccordionSubTitle, AccordionTitle } from "@vds/accordions";

import { Table, TableBody, TableHead, TableHeader, TableRow, Cell } from "@vds/tables";

const PaddingZero = styled.div`
padding-bottom:16px;

`;
const CoverageLink = styled(TextLink)`
color: blue;
`;

const TableBox = styled(Table)`
border: 1px solid #A7A7A7;
width:100%;


`;
const StyledDesc = styled.div`
color: #6F7171;
font-size: 1rem;

`
const CellBody = styled(Cell)`
padding: 10px !important;
font-family: Verizon-NHG-eTX;
font-size: 12px;
`;

const TableHeaderBox1 = styled(TableHeader)`
padding: 10px !important;
width:30%
`;
const TableHeaderBox2 = styled(TableHeader)`
padding: 10px !important;
width:30%
`;
const TableHeaderBox3 = styled(TableHeader)`
padding: 10px !important;
width:40%
`;


const StyledTitleDiv = styled.div`
padding-top:48px;

`

const StyledPaddingDiv = styled.div`
padding-top:24px;

`
const StyledPaddingDiv1 = styled.div`
padding-top:24px;
padding-bottom:24px;

`

const InternationalDialingInstrcution = ({ dialingInstruction }) => {

    let dialingInstrcutionCategoryContent = dialingInstruction?.categoryContent;

    return (
        <React.Fragment>
            <StyledTitleDiv>
                <Title
                    size="small"
                    color="#000000"
                    bold={false}>
                    {dialingInstruction && dialingInstruction.dialingInstructionTitle}
                </Title>
            </StyledTitleDiv>
            <>
                {dialingInstrcutionCategoryContent && dialingInstrcutionCategoryContent.map((CategoryContent, idx) =>
                    CategoryContent && CategoryContent.content && CategoryContent.content.map((item, index) => (
                        <React.Fragment>
                            <StyledPaddingDiv></StyledPaddingDiv>
                            <Body size="medium">
                                {item &&
                                    <span dangerouslySetInnerHTML={{ __html: item.header }} />}
                            </Body>
                            <PaddingZero></PaddingZero>
                            {item && item.header != "<b>International Services Support</b>" && item.value.map((ele, index) => (

                                <ul
                                    size="bodyLarge"
                                    viewport="desktop"
                                    surface="light"
                                >
                                    <Body size="medium">
                                        <li><span dangerouslySetInnerHTML={{ __html: ele.key }} /></li>
                                    </Body>

                                    {ele && ele.sub && ele.sub.map((subele, index) => (
                                        <ul>
                                            <li><Body size="medium"><span dangerouslySetInnerHTML={{ __html: subele.key }} /></Body></li></ul>))}


                                </ul>
                            ))}


                            {item.header === "<b>International Services Support</b>" && item.value.map((ele, index) =>

                                <Body size="medium">
                                    <div dangerouslySetInnerHTML={{ __html: ele.key }} />
                                </Body>)}

                        </React.Fragment>)))}
            </>
            {dialingInstruction &&
                <StyledPaddingDiv>
                    <Body size="medium"> {dialingInstruction.coverageMapText}
                        <CoverageLink color="blue" bold="false" data-testid="coverageLinkId" onClick={e => window.open(dialingInstruction.coverageMapLink)}> {dialingInstruction.coverageMapTextLink}</CoverageLink></Body>
                </StyledPaddingDiv>}
            {dialingInstruction &&
                <StyledPaddingDiv1>
                    <Title size="medium">{dialingInstruction.selectedCountriesText}</Title>
                </StyledPaddingDiv1>}
            <Accordion>
                {dialingInstruction && dialingInstruction.content && dialingInstruction.content.map((item, index) => (
                    <React.Fragment>
                        <AccordionItem>
                            <AccordionHeader
                                triggerType="icon"
                            >
                                <AccordionTitle><Title><Body size="large">{item && item.country}</Body></Title></AccordionTitle>
                                <AccordionSubTitle><StyledDesc>{item && item.countryDesc}</StyledDesc ></AccordionSubTitle>
                            </AccordionHeader>
                            <AccordionDetail>
                                <TableBox
                                    striped={false}
                                    bottomLine="secondary"
                                    surface="light"
                                >
                                    <TableHead bottomLine="primary">
                                        <TableHeaderBox1><Body size="small" bold={true}>{item && <span dangerouslySetInnerHTML={{ __html: item.countryCodeText }} />}</Body>
                                        </TableHeaderBox1>
                                        <TableHeaderBox2><Body size="small" bold={true}>{item && <span dangerouslySetInnerHTML={{ __html: item.dialingToText }} />}</Body>
                                        </TableHeaderBox2>
                                        <TableHeaderBox3><Body size="small" bold={true}>{item && <span dangerouslySetInnerHTML={{ __html: item.dialingInstructionText }} />}</Body></TableHeaderBox3>
                                    </TableHead>
                                    <TableBody>
                                        {item && item.itpdialtable && item.itpdialtable.map((ele, i) => (
                                            <TableRow>
                                                <CellBody>
                                                    <Body size="small"></Body>{ele && i == 0 && ele.country_code}<Body></Body>
                                                </CellBody>
                                                <CellBody>
                                                    <Body size="small"></Body>{ele && ele.dialing_to}<Body></Body>
                                                </CellBody>
                                                <CellBody>
                                                    <Body size="small"></Body>{ele && ele.instruction}<Body></Body></CellBody>
                                            </TableRow>))}

                                    </TableBody>
                                </TableBox>
                            </AccordionDetail>
                        </AccordionItem>
                    </React.Fragment>
                ))}
            </Accordion>
        </React.Fragment>)
}

export default InternationalDialingInstrcution ;